import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Paciente/paciente';
import PacienteCrear from './PacienteCrear';

const mstp = state => {
    return {...state.paciente}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(PacienteCrear)
